import { render, staticRenderFns } from "./V2Button.vue?vue&type=template&id=46c15c22&scoped=true&"
import script from "./V2Button.vue?vue&type=script&lang=js&"
export * from "./V2Button.vue?vue&type=script&lang=js&"
import style0 from "./V2Button.vue?vue&type=style&index=0&id=46c15c22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c15c22",
  null
  
)

export default component.exports